export const Partner = {
  getPartner: {
    url: '/partner',
    method: ['GET'],
  },
  savePartner: {
    url: '/partner',
    method: ['PUT'],
  },
  getPartnerInfo: {
    url: '/partner/infos',
    method: ['GET'],
  },
  getPartnerGeneral: {
    url: '/partner/general',
    method: ['GET'],
  },
  getPartnerSales: {
    url: '/partner/sales',
    method: ['GET'],
  },
  enable: {
    url: '/partner/enable',
    method: ['POST'],
  },
  getInfluencerStatus: {
    url: '/partner/influencerStatus',
    method: ['GET'],
  },
  getPayment: {
    url: '/partner/payment',
    method: ['GET'],
  },
  updatePayment: {
    url: '/partner/payment',
    method: ['PUT'],
    required: ['paymentStatus'],
  },
  getCurrentResults: {
    url: '/partner/results',
    method: ['GET'],
  },
  getAllResults: {
    url: '/partner/allResults/{limit}&{startPeriod}&{endPeriod}',
    method: ['GET'],
  },
  getResultsByBU: {
    url: '/partner/results/businessUnity',
    method: ['GET'],
  },
  getCampaigns: {
    url: '/partner/campaigns',
    method: ['GET'],
  },
  getCampaignsResults: {
    url: '/partner/results/campaigns',
    method: ['GET'],
  },
  subscribeCampaign: {
    url: '/partner/campaign/subscribe',
    method: ['POST'],
  },
  subscribeChallenge: {
    url: '/partner/campaign/subscribeStatus',
    method: ['POST'],
  },
  createIssue: {
    url: '/partner/campaign/issue',
    method: ['POST'],
  },
  deleteCampaignReceipt: {
    url: '/partner/delete/receipt',
    method: ['POST'],
  },
  getCampaignReceipts: {
    url: '/partner/campaign/receipts',
    method: ['GET'],
  },
  uploadCampaignReceipts: {
    url: '/partner/upload/receipt',
    method: ['POST'],
  },
  isAdmin: {
    url: '/partner/admin',
    method: ['GET'],
  },
  saveSocial: {
    url: '/partner/links',
    method: ['PUT'],
  },
  createHelp: {
    url: '/partner/help',
    method: ['POST'],
  },
  createHelpFiles: {
    url: '/partner/help/file',
    method: ['POST'],
  },
  getHelpSent: {
    url: '/partner/help',
    method: ['GET'],
  },
  getHelpFilesSent: {
    url: '/partner/help/files',
    method: ['GET'],
  },
  updateHelp: {
    url: '/partner/help',
    method: ['PUT'],
  },
  getPaymentRegistry: {
    url: '/partner/payment/registry',
    method: ['GET'],
  },

  getCurrentComissions: {
    url: '/partner/comissions',
    method: ['GET'],
  },

  getSalesCount: {
    url: '/partner/salesquantity',
    method: ['GET'],
  },

  getSalesQuantityRule: {
    url: '/partner/salesquantityrule',
    method: ['GET'],
  },

  acceptGlamstarTerms: {
    url: '/partner/accept/glamstar',
    method: ['GET'],
  },
  createGlamqueenCoupon:{
    url: '/partner/glamqueencouponcreate',
    method: ['POST']
  },
  glamqueenCoupon:{
    url: '/partner/GlamqueenCoupon',
    method: ['POST']
  }
};
